module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-152x152.22b6c7a66f92bc5e10154aa02885d088.png";